import $ from 'jquery';

export default class GoogleMap {
  constructor(element) {
    this.$el = $(element.el);
    this.mapCanvas = '[data-google-map]';
    this.$mapCanvas = this.$el.find(this.mapCanvas);
    this.context = JSON.parse(this.$el.find('[data-google-map-json]').text());
    this.infoBoxURL = this.$mapCanvas.data('infobox-url');

    this._getGoogleScript();
  }

  _getGoogleScript() {
    let googleMapsURL;
    if (this.context.apiKey.length) {
      googleMapsURL = `https://maps.googleapis.com/maps/api/js?key=${this.context.apiKey}`;
    } else {
      googleMapsURL = 'https://maps.googleapis.com/maps/api/js';
    }

    if (typeof window.google === 'undefined') {
      $.getScript(
        googleMapsURL,
      ).done((script, textStatus) => this._getGoogleInfoBoxScript(textStatus)).fail((jqxhr, settings, exception) => this._scriptFailed('GoogleMaps', { jqxhr, settings, exception }));
    }
    this._getGoogleInfoBoxScript('success');
  }

  _getGoogleInfoBoxScript(textStatus) {
    if (textStatus !== 'success') {
      this._scriptFailed('GoogleMaps');
    }

    $.getScript(
      this.infoBoxURL,
    ).done((script, textStatus) => this._infoBoxLoaded(textStatus)).fail((jqxhr, settings, exception) => this._scriptFailed('Infobox', { jqxhr, settings, exception }));
  }

  _scriptFailed(scriptName, options) {
    if (options == null) { options = {}; }
    console.warn(`${scriptName} failed to load`);
    if (options != null) { return console.warn(options); }
  }

  _hasErrors(status) {
    let errorMessage;
    switch (status) {
      case 'ZERO_RESULTS':
        errorMessage = this.context.addressNoResults;
        break;
      case 'OVER_QUERY_LIMIT':
        errorMessage = this.context.addressQueryLimit;
        break;
      default:
        errorMessage = this.context.addressError;
    }

    this.$mapCanvas.append(`<div class="module-map-error">${errorMessage}</div>`);
  }

  _infoBoxLoaded(textStatus) {
    if (textStatus !== 'success') {
      this._scriptFailed('Infobox');
    }

    this.geocoder = new (google.maps.Geocoder)();

    this.geocoder.geocode({ address: this.context.address }, (results, status) => {
      if (status !== google.maps.GeocoderStatus.OK) { return this._hasErrors(status); }

      this.$el.addClass('has-map');

      const stylesArray = [
        {
          featureType: 'administrative',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#444444' }],
        },
        {
          featureType: 'landscape',
          elementType: 'all',
          stylers: [{ color: '#f2f2f2' }],
        },
        {
          featureType: 'poi',
          elementType: 'all',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'road',
          elementType: 'all',
          stylers: [
            { saturation: -100 },
            { lightness: 45 },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'all',
          stylers: [{ visibility: 'simplified' }],
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'transit',
          elementType: 'all',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'water',
          elementType: 'all',
          stylers: [
            { color: '#419bf9' },
            { visibility: 'on' },
          ],
        },
      ];

      const mapOptions = {
        center: {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng(),
        },
        zoom: 15,
        styles: stylesArray,
        scrollwheel: false,
      };

      const map = new (google.maps.Map)(document.querySelector(this.mapCanvas), mapOptions);
      const marker = new (google.maps.Marker)({
        position: mapOptions.center,
      });

      marker.setMap(map);

      const infobox = new InfoBox({
        content: `<div class='info-box-container'>${this.context.title}</div>`,
        disableAutoPan: false,
        pixelOffset: new (google.maps.Size)(0, -120),
        zIndex: null,
        closeBoxURL: '',
        infoBoxClearance: new (google.maps.Size)(1, 1),
      });

      infobox.open(map, marker);

      google.maps.event.addDomListener(window, 'resize', () => setTimeout(() => map.setCenter(mapOptions.center),
        100));
    });
  }
}
